import { OrganizationLoader } from '@/pages/OrganizationLoader';

import { Content } from './Content';
import { Sidebar } from './Sidebar';

export const LayoutMain = () => {
  return (
    <OrganizationLoader>
      {/* <LogoutWarning /> */}
      <Sidebar />
      <Content />
    </OrganizationLoader>
  );
};

export default LayoutMain;
